import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import IssueIcon from 'ui/images/top/topIssue_icon.svg';
import IssueImg01 from 'ui/images/top/topIssue_img01@2x.png';
import IssueImg02 from 'ui/images/top/topIssue_img02@2x.png';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    padding: 5rem 0;
    position: relative;
    background-color: #e7e7e7;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    &::after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent transparent var(--light-orange) transparent;
        border-width: 0px 19px 23px 19px;
        margin: 0 auto 0 auto;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
    }

    ${mqMin('NARROW')} {
        padding: 5rem 0 3rem;
    }
`;

const H2 = styled.h2`
    text-align: center;
    font-size: 1.29rem;
    line-height: 1.8em;
    letter-spacing: 0.05em;
    margin-bottom: 2rem;

    &::after {
        position: absolute;
        top: -32px;
        left: 62%;
        content: '';
        display: block;
        width: 34px;
        height: 34px;
        background-image: url(${IssueIcon});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: auto;
    }

    ${mqMin('NARROW')} {
        margin-bottom: 3rem;
        font-size: 1.5rem;
        letter-spacing: 0.1em;
    }
`;

const ExampleContainer = styled.div`
    margin-bottom: 62px;
    max-width: 1512px;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        display: flex;
        justify-content: center;
        margin-bottom: 72px;
    }
`;

const ExampleItem = styled.div`
    position: relative;
    border-radius: 11px;
    background-color: #fff;
    margin: 0 auto 0 auto;
    padding: 1rem 0.889rem;
    text-align: center;
    width: 21.85rem;

    ${mqMin('NARROW')} {
        margin-left: auto;
        width: initial;
    }
`;

const ExampleItemText = styled.div`
    line-height: 1.5em;
    letter-spacing: 0.1em;
    font-size: 0.84rem;

    ${mqMin('NARROW')} {
        font-size: 0.889rem;
    }
`;

const IssueImg = styled.img`
    position: absolute;
    bottom: -5.5rem;
    width: 6.222rem;
    height: auto;
    z-index: 1;

    ${mqMin('NARROW')} {
        position: absolute;
        top: -1.5rem;
        bottom: auto;
        width: 6.222rem;
        height: auto;
    }
`;

const IssueImg01Item = styled(IssueImg)`
    right: 0;
    width: 4.9rem;
    bottom: -5.5rem;

    ${mqMin('SP')} {
        right: 0rem;
        width: 9.9rem;
    }

    ${mqMin('NARROW')} {
        left: 16rem;
        right: auto;
        bottom: auto;
        width: 6.22rem;
    }
`;

const IssueImg02Item = styled(IssueImg)`
    left: -5px;
    width: 4.7rem;

    ${mqMin('SP')} {
        width: 9.7rem;
    }

    ${mqMin('NARROW')} {
        left: auto;
        right: 16rem;
        width: 6.22rem;
    }
`;

const ExampleItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ${mqMin('SP')} {
        max-width: 500px;
        margin: 0 auto;
    }

    ${mqMin('NARROW')} {
        max-width: initial;
        margin: 0 auto;
    }
`;

const ExampleItemTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ${mqMin('SP')} {
        flex-direction: row;
    }
`;

export const Issue: React.FC = () => {
    return (
        <Container>
            <H2 className="fadein fadein_y">
                M&Aでの買収を考えているけど...
                <Only sp>
                    <br />
                </Only>
                こんなお悩みありませんか？
            </H2>
            <ExampleContainer className="fadein fadein_y">
                <IssueImg01Item src={IssueImg01} alt="悩みのイメージ1" />
                <ExampleItems>
                    <ExampleItemTop>
                        <ExampleItem>
                            <ExampleItemText>希望にマッチした案件の提案が少ない</ExampleItemText>
                        </ExampleItem>
                        <ExampleItem>
                            <ExampleItemText>どこに相談したらいいのかわからない</ExampleItemText>
                        </ExampleItem>
                    </ExampleItemTop>
                    <ExampleItem>
                        <ExampleItemText>
                            手紙や電話での提案だと、
                            <Only sp>
                                <br />
                            </Only>
                            本当に案件があるのか信用できない
                        </ExampleItemText>
                    </ExampleItem>
                </ExampleItems>
                <IssueImg02Item src={IssueImg02} alt="悩みのイメージ2" />
            </ExampleContainer>
        </Container>
    );
};
